"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Environment = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
exports.Environment = {
    int: function (envVar, defaultValue) {
        if (defaultValue === void 0) { defaultValue = 0; }
        if (envVar === undefined)
            return defaultValue;
        return parseInt(envVar);
    },
    float: function (envVar, defaultValue) {
        if (defaultValue === void 0) { defaultValue = 0; }
        if (envVar === undefined)
            return defaultValue;
        return parseFloat(envVar);
    },
    string: function (envVar, defaultValue) {
        if (defaultValue === void 0) { defaultValue = ""; }
        if (envVar === undefined)
            return defaultValue;
        return envVar;
    },
    array: function (envVar, defaultValue) {
        if (defaultValue === void 0) { defaultValue = []; }
        if (envVar === undefined)
            return defaultValue;
        return JSON.parse(envVar);
    },
    object: function (envVar, defaultValue) {
        if (envVar === undefined)
            return defaultValue;
        return JSON.parse(envVar);
    },
    bool: function (envVar, defaultValue) {
        if (defaultValue === void 0) { defaultValue = false; }
        if (envVar === undefined)
            return defaultValue;
        if (envVar === "1" || envVar == "0")
            return !!parseInt(envVar);
        return JSON.parse(envVar);
    },
};
